import { useInventoryMetrics } from "../../hooks/useInventory";
import { useRecentMovements } from "../../hooks/useInventory";
import {
  Skeleton, Badge
} from '@tonic/shared/components/ui';
;
import { formatDistanceToNow } from "date-fns";
import { Eye, Edit, Trash } from "lucide-react";

export function RecentMovements() {
  const { data: metrics, isLoading } = useInventoryMetrics();

  if (isLoading) {
    return (
      <div className="space-y-4">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center justify-between space-x-4">
            <Skeleton className="h-12 w-12 rounded-full" />
            <div className="flex flex-col flex-1 space-y-2">
              <Skeleton className="h-4 w-[200px]" />
              <Skeleton className="h-4 w-[150px]" />
            </div>
            <Skeleton className="h-8 w-[100px]" />
          </div>
        ))}
      </div>
    );
  }

  if (!metrics?.recentMovements?.length) {
    return (
      <div className="flex justify-center items-center py-6">
        <span className="text-gray-500">No recent movements</span>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {metrics.recentMovements.map((movement) => (
        <div
          key={movement.id}
          className="flex items-center justify-between rounded-lg border p-4"
        >
          <div className="flex flex-col gap-1">
            <span className="font-medium">
              {movement.productName}
            </span>
            <span className="text-sm text-gray-500">
              SKU: {movement.sku}
            </span>
          </div>
          <div className="flex items-center space-x-2">
            <Badge variant={movement.type === 'in' ? 'success' : 'destructive'}>
              {movement.type === 'in' ? 'Received' : 'Shipped'}
            </Badge>
            <span className="text-sm text-gray-500">
              {formatDistanceToNow(new Date(movement.timestamp), { addSuffix: true })}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
} 
